<template>
    <div class="container bando-corso-editor">
        <div class="row">
            <div class="col-md-12" id="autocomplete_container">
                <h4>Corsi e moduli</h4>
            </div>
        </div>

        <div class="row pb-0 mt-0 mb-0">
            <div class="col-md-12" style="color:darkred; font-weight: bold; text-align: center;">
                Importante NON DUPLICARE I NOMI DI MODULO nello stesso corso, Importante Specificare nomi di corso
                sempre diversi. Si possono causare incongruenze sui dati finali.
            </div>
            <div class="col-md-4">Corso</div>
            <div class="col-md-1">Durata</div>
            <div class="col-md-1">Provincia</div>
            <div class="col-md-2">Sede</div>
            <div class="col-md-1">Moduli</div>
            <div class="col-md-1">Gruppi</div>
            <div class="col-md-2">&nbsp;</div>
        </div>
        <div class="row pb-0 mt-0 mb-0 border-t-1 border-light" v-for="(corso,csid) in finalData.corsi"
             :key="'cs_'+csid">
            <div class="col-md-4 pt-1 pb-0 mt-0 mb-0 ">
                <v-text-field v-model="corso.nome" placeholder="nome corso" dense
                              @blur="fixInput(corso.nome)"></v-text-field>

            </div>
            <div class="col-md-1 pt-1 pb-0 mt-0 mb-0 ">
                <v-text-field v-model="corso.durata" type="number" placeholder="durata in ore" dense></v-text-field>
                <span v-if="verificaModuli(corso)" class="text--danger">
                    <v-icon class="text--warning" style="color:orange;">mdi-alert</v-icon>
                    ATTENZIONE; totale moduli ({{ totaleCorso(corso) }}) , non corrisponde con durata corso
                </span>
            </div>
            <div class="col-md-1 pt-1 pb-0 mt-0 mb-0 ">
                <v-autocomplete
                    attach
                    dense
                    :items="province"
                    :filter="customFilter"
                    color="white"
                    item-text="provincia"
                    item-value="sigla"
                    v-model="corso.provincia"
                    label="Provincia"
                ></v-autocomplete>
            </div>
            <div class="col-md-2 pt-1 pb-0 mt-0 mb-0 ">
                <v-autocomplete
                    attach
                    dense
                    :items="sedi"
                    :filter="customFilter"
                    color="white"
                    item-text="sede"
                    item-value="sede"
                    v-model="corso.sede"
                    label="Sede"
                ></v-autocomplete>
            </div>
            <div class="col-md-1 pt-1 pb-0 mt-0 mb-0 ">{{ corso.moduli.length }}&nbsp;
                <v-btn @click="openModuleDialog(csid,corso)" color="secondary">
                    <v-icon class="text--white">mdi-pencil</v-icon>
                </v-btn>
            </div>
            <div class="col-md-1 pt-1 pb-0 mt-0 mb-0 ">{{ corso.gruppi.length }}&nbsp;
                <v-btn @click="openGroupDialog(csid,corso)" color="secondary">
                    <v-icon class="text--white">mdi-pencil</v-icon>
                </v-btn>
            </div>
            <div class="col-md-2 pt-1 pb-0 mt-0 mb-0 ">
                <v-btn @click="removeCorso(corso)" color="error">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-btn @click="cloneCorso(csid)" color="blue-grey">
                    <v-icon class="text--white" style="color:#FFF;">mdi-content-copy</v-icon>
                </v-btn>
            </div>
        </div>
        <div class="row pb-0 mb-0 border-t-1 border-light">
            <div class="col-md-12 text-right pb-0 mt-0 mb-0 ">
                <v-btn @click="importCorsi" color="secondary">
                    <v-icon class="glyphicon glyphicon-import"></v-icon>
                    Importa corsi
                </v-btn>
                <v-btn @click="addCorso" color="primary">
                    <v-icon class="glyphicon-plus"></v-icon>
                    Aggiungi corso
                </v-btn>
            </div>
        </div>
        <v-dialog

            v-model="modalModuli.show"
            max-width="70%">
            <v-card v-if="modalModuli.corsoobj">
                <v-card-title class="headline">Gestisci moduli del corso {{ modalModuli.corsoobj.nome }}</v-card-title>
                <v-card-text>
                    <div class="container-fluid">
                        <div class="row pb-0 mt-0 mb-0">
                            <div class="col-md-12" style="color:darkred; font-weight: bold; text-align: center;">
                                Importante NON DUPLICARE I NOMI DI MODULO. Si possono causare incongruenze sui dati
                                finali.
                            </div>
                            <div class="col-md-3">Modulo</div>
                            <div class="col-md-2">Durata</div>
                            <div class="col-md-2">Fascia Prof.</div>
                            <div class="col-md-2">Fascia Did.</div>

                            <div class="col-md-3">&nbsp;</div>
                        </div>
                        <div class="row pb-0 mt-0 mb-0 border-t-1 border-light"
                             v-for="(modulo,csid) in modalModuli.corsoobj.moduli" :key="'md_'+csid">
                            <div class="col-md-3 pt-1 pb-0 mt-0 mb-0 ">
                                <v-text-field v-model="modulo.modulo" placeholder="nome modulo" dense
                                              @blur="fixInput(modulo.modulo)"></v-text-field>

                            </div>
                            <div class="col-md-2 pt-1 pb-0 mt-0 mb-0 ">
                                <v-text-field v-model="modulo.durata" type="number" placeholder="durata in ore"
                                              dense></v-text-field>
                            </div>
                            <div class="col-md-2 pt-1 pb-0 mt-0 mb-0 ">
                                <v-select
                                    dense
                                    :items="fasce"
                                    v-model="modulo.fascia_prof"
                                    item-text="text"
                                    item-value="fascia"
                                ></v-select>
                            </div>
                            <div class="col-md-2 pt-1 pb-0 mt-0 mb-0 ">
                                <v-select
                                    dense
                                    :items="fasce"
                                    v-model="modulo.fascia_did"
                                    item-text="text"
                                    item-value="fascia"
                                ></v-select>
                            </div>
                            <div class="col-md-3 pt-1 pb-0 mt-0 mb-0 ">
                                <v-btn @click="removeModulo(modulo)" color="error">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn @click="cloneModule(csid)" color="blue-grey">
                                    <v-icon class="text--white" style="color:#FFF;">mdi-content-copy</v-icon>
                                </v-btn>
                            </div>
                            <div class="col-md-8 pt-1 pb-0 mt-0 mb-0 ">
                                <v-text-field v-model="modulo.note" placeholder="note o esperienza specifica"
                                              dense></v-text-field>

                            </div>
                            <div class="col-md-4 pt-1 pb-0 mt-0 mb-0 ">
                                <v-select
                                    dense
                                    :items="modalModuli.corsoobj.gruppi"
                                    v-model="modulo.gruppo"
                                    item-text="gruppo"
                                    item-value="gruppo"
                                ></v-select>

                            </div>
                        </div>
                        <div class="row pb-0 mb-0 border-t-1 border-light">
                            <div class="col-md-12 text-right pb-0 mt-0 mb-0 ">
                                <v-btn @click="addModulo" color="primary">
                                    <v-icon class="glyphicon-plus"></v-icon>
                                    Aggiungi modulo
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <div class="flex flex-wrap row justify-center" style="max-width: 70%;"
                         v-if="finalData.corsi.length>1">
                        <h6 class="flex-grow-1" style="width: 100%;">Importa moduli da corso</h6>
                        <v-select dense v-model="modalModuli.sourceid"
                                  :items="finalData.corsi.filter((v)=>v!==modalModuli.corsoobj)" item-text="nome"
                                  return-object></v-select>
                        <v-btn @click="copyModulesFromCorso(modalModuli.sourceid,modalModuli.corsoid)"
                               color="blue-grey">
                            <v-icon class="text--white" style="color:#FFF;">mdi-content-copy</v-icon>
                        </v-btn>
                    </div>
                    <div class="flex flex-wrap row justify-center"
                         style="max-width: 40%; color:darkred; font-weight: bold;">
                        Importante NON DUPLICARE I NOMI DI MODULO. Si possono causare incongruenze sui dati finali.
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="modalModuli.show=false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog

            v-model="modalGroup.show"
            max-width="70%">
            <v-card v-if="modalGroup.corsoobj">
                <v-card-title class="headline">Gestisci gruppi di moduli per il corso {{
                        modalGroup.corsoobj.nome
                    }}
                </v-card-title>
                <v-card-text>
                    <div class="container-fluid">
                        <div class="row pb-0 mt-0 mb-0">
                            <div class="col-md-12" style="color:darkred; font-weight: bold; text-align: center;">
                                Importante NON DUPLICARE I NOMI DI GRUPPO. Si possono causare incongruenze sui dati
                                finali.
                            </div>
                            <div class="col-md-3">Gruppo</div>
                            <div class="col-md-6">Descrizione</div>
                            <div class="col-md-3">&nbsp;</div>
                        </div>
                        <div class="row pb-0 mt-0 mb-0 border-t-1 border-light"
                             v-for="(modulo,csid) in modalGroup.corsoobj.gruppi" :key="'gp_'+csid">
                            <div class="col-md-3 pt-1 pb-0 mt-0 mb-0 ">
                                <v-text-field v-model="modulo.gruppo" placeholder="nome gruppo" dense
                                              @blur="fixInput(modulo.gruppo)"></v-text-field>

                            </div>
                            <div class="col-md-6 pt-1 pb-0 mt-0 mb-0 ">
                                <v-textarea v-model="modulo.descrizione" placeholder="descrizione gruppo"
                                            dense></v-textarea>
                            </div>
                            <div class="col-md-3 pt-1 pb-0 mt-0 mb-0 ">
                                <v-btn @click="removeGruppo(modulo)" color="error">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                                <v-btn @click="cloneGruppo(csid)" color="blue-grey">
                                    <v-icon class="text--white" style="color:#FFF;">mdi-content-copy</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <div class="row pb-0 mb-0 border-t-1 border-light">
                            <div class="col-md-12 text-right pb-0 mt-0 mb-0 ">
                                <v-btn @click="addGruppo" color="primary">
                                    <v-icon class="glyphicon-plus"></v-icon>
                                    Aggiungi gruppo
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <div class="flex flex-wrap row justify-center"
                         style="max-width: 40%; color:darkred; font-weight: bold;">
                        Importante NON DUPLICARE I NOMI DI GRUPPO. Si possono causare incongruenze sui dati finali.
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="modalGroup.show=false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog

            v-model="modalImport.show"
            max-width="70%">
            <v-card>
                <v-card-title class="headline">Importa corsi e moduli</v-card-title>
                <v-card-text>
                    <div class="container-fluid">
                        <div class="row pb-0 mt-0 mb-0">
                            <div class="col-md-12" style="color:darkred; font-weight: bold; text-align: center;">
                                Importante utilizzare esclusivamente il file excel per l'importazione.
                            </div>
                            <div class="col-md-6" style="color:darkred; font-weight: bold; text-align: center;">
                                <b>Istruzioni</b>
                                <ol>
                                    <li>Scarica il modello per l'importazione</li>
                                    <li>Compilalo in ogni sua parte seguendo le istruzioni</li>
                                    <li>Carica il file nel box qui a destra e clicca su "Avvia importazione"</li>
                                    <li>Verifica l'articolazione rilevata</li>
                                    <li>Concludi l'importazione cliccando il tasto "Finalizza importazione"</li>
                                </ol>
                            </div>
                            <div class="6" style="color:darkred; font-weight: bold; text-align: center;">
                                <a :href="importformat" target="_blank" download="format_bando">Scarica il modello di
                                    importazione</a><br/>
                                <hr/>
                                <label for="import_file">Inserisci il file excel da importare</label>
                                <input type="file" id="import_file"
                                       @change="startImport"
                                       accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>

                            </div>

                        </div>
                        <div class="row pb-0 mt-0 mb-0">
                            <div class="col-md-12">
                                Anteprima importazione
                                <div class="importlist" v-if="modalImport.corsi.length > 0">
                                    <div v-for="(corso, index) in modalImport.corsi" :key="index" class="corso-box">
                                        <h3>{{ corso.nome }}</h3>
                                        <div class="corso-info">
                                            <p><strong>Sede:</strong> {{ corso.sede }}</p>
                                            <p><strong>Provincia:</strong> {{ corso.provincia }}</p>
                                            <p><strong>Durata corso:</strong> {{ corso.durata }} ore</p>
                                        </div>

                                        <table class="moduli-table">
                                            <thead>
                                            <tr>
                                                <th>Modulo</th>
                                                <th>Durata</th>
                                                <th>Fascia Prof.</th>
                                                <th>Fascia Did.</th>
                                                <th>Note</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(modulo, mIndex) in corso.moduli" :key="mIndex">
                                                <td>{{ modulo.modulo }}</td>
                                                <td>{{ modulo.durata }}</td>
                                                <td>{{ modulo.fascia_prof }}</td>
                                                <td>{{ modulo.fascia_did }}</td>
                                                <td>{{ modulo.note }}</td>
                                            </tr>
                                            </tbody>
                                        </table>

                                        <hr/>
                                    </div>
                                </div>
                                <div class="importlist" v-else>
                                    <em>Nessun corso importabile</em>
                                </div>
                            </div>
                        </div>
                        <div class="row pb-0 mb-0 border-t-1 border-light">
                            <div class="col-md-12 text-right pb-0 mt-0 mb-0 ">
                                <v-btn @click="finishImport" color="primary" :disabled="modalImport.corsi.length === 0">
                                    <v-icon class="glyphicon-plus"></v-icon>
                                    Finalizza importazione
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="modalImport.show=false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>
<script>
var moment = require('moment');
const _ = require('lodash');
const _fasce = [
    {"fascia": "A", text: "A (>= 5 anni)"},
    {"fascia": "B", text: "B (>= 3 anni)"},
    {"fascia": "C", text: "C (>= 0 anni)"},
    {"fascia": "", text: "Non docente/Nessuna fascia"},
]
moment.locale("it");

var axios = require('axios');
export default {
    props: {
        "importapi": {
            type: String,
            default: ""
        },
        "importformat": {
            type: String,
            default: ""
        },
        "province": {
            type: Array,
            default: () => []
        },
        "sedi": {
            type: Array,
            default: () => []
        },
        "output": "",
        "source": {
            type: Object,
            default: () => {
            }
        }
    },
    computed: {
        fasce: function () {
            return _fasce;
        }
    },
    data() {
        return {
            isLoading: false,
            "ready": false,
            "finalData": {
                "corsi": []
            },
            modalModuli: {
                show: false,
                corsoid: null,
                corsoobj: null,
                sourceid: null
            },
            modalImport: {
                show: false,
                corsi: []
            },
            modalGroup: {
                show: false,
                corsoid: null,
                corsoobj: null,
                sourceid: null
            }
        }
    },
    watch: {
        finalData: {
            handler(newValue, oldValue) {
                if (this.output) {
                    document.getElementById(this.output).value = JSON.stringify(this.finalData);
                }
            },
            deep: true
        }
    },
    methods: {
        preventWhiteSpaces(object) {
            if (Array.isArray(object)) {
                object = object.map((itemA) => {
                    itemA = this.preventWhiteSpaces(itemA)
                    return itemA
                });
            } else if (typeof object === 'object') {
                const _keys = Object.keys(object)
                _keys.map((k) => {
                    let value = object[k];
                    if (typeof value === 'object') {
                        value = this.preventWhiteSpaces(value)
                    } else if (Array.isArray(value)) {
                        value = value.map((itemA) => {
                            itemA = this.preventWhiteSpaces(itemA)
                            return itemA
                        });
                    }
                    if (k === 'nome' || k === "corso" || k === 'provincia') {
                        value = value.trim();
                    }
                    object[k] = value;
                })
            }
            return object
        },
        fixInput(text) {
            text = text.trim();
        },
        totaleCorso(corso) {
            return corso.moduli.reduce((carry, item) => {
                return carry + parseInt(item.durata);
            }, 0);
        },
        verificaModuli(corso) {
            const dur = parseInt(corso.durata);
            const moduli = corso.moduli.reduce((carry, item) => {
                return carry + parseInt(item.durata);
            }, 0);
            return dur !== moduli;
        },
        customFilter(item, queryText, itemText) {
            const textOne = typeof (item.provincia) !== 'undefined' ? item.provincia.toLowerCase() : ""
            const textTwo = typeof (item.sigla) !== 'undefined' ? item.sigla.toLowerCase() : ""
            const searchText = queryText.toLowerCase();
            if (textOne.length > 0) {
                return textOne.indexOf(searchText) > -1 ||
                    textTwo.indexOf(searchText) > -1
            }
            return itemText.indexOf(searchText) > -1
        },
        addModulo() {
            this.finalData.corsi[this.modalModuli.corsoid].moduli.push({
                "gruppo": "",
                "modulo": "",
                "durata": 0,
                "note": "",
                "fascia_prof": "C",
                "fascia_did": "C"
            });
        },
        addGruppo() {
            this.finalData.corsi[this.modalGroup.corsoid].gruppi.push({
                "gruppo": "",
                "descrizione": ""
            });
        },
        removeGruppo(obj) {
            this.finalData.corsi[this.modalGroup.corsoid].gruppi.splice(this.finalData.corsi[this.modalGroup.corsoid].gruppi.indexOf(obj), 1);
        },
        removeModulo(obj) {
            this.finalData.corsi[this.modalModuli.corsoid].moduli.splice(this.finalData.corsi[this.modalModuli.corsoid].moduli.indexOf(obj), 1);
        },
        copyModulesFromCorso(source, dest_id) {
            const newModules = _.cloneDeep(source.moduli);
            this.$set(this.finalData.corsi[dest_id], 'moduli', newModules);
            this.modalModuli.sourceid = null;
        },
        cloneModule(id) {
            const _module = _.cloneDeep(this.finalData.corsi[this.modalModuli.corsoid].moduli[id]);
            this.finalData.corsi[this.modalModuli.corsoid].moduli.push(_module);
        },
        cloneGruppo(id) {
            const _module = _.cloneDeep(this.finalData.corsi[this.modalGroup.corsoid].gruppi[id]);
            this.finalData.corsi[this.modalGroup.corsoid].gruppi.push(_module);
        },
        cloneCorso(id) {
            const _corso = _.cloneDeep(this.finalData.corsi[id]);
            this.finalData.corsi.push(_corso);
        },
        openModuleDialog(id, cs) {
            this.modalModuli.corsoid = id;
            this.modalModuli.corsoobj = cs;
            this.modalModuli.show = true;
        },
        openGroupDialog(id, cs) {
            this.modalGroup.corsoid = id;
            this.modalGroup.corsoobj = cs;
            this.modalGroup.show = true;
        },
        removeCorso(obj) {
            this.finalData.corsi.splice(this.finalData.corsi.indexOf(obj), 1);
        },
        addCorso() {
            this.finalData.corsi.push({
                "corso": "",
                "durata": 0,
                "provincia": "",
                "sede": "",
                "moduli": [],
                "gruppi": []
            });
        },
        importCorsi() {
            this.modalImport.show = true;
        },
        async startImport(event) {
            const file = event.target.files[0];
            if (!file) {
                alert('Nessun file selezionato');
                return;
            }
            const formData = new FormData();
            this.$set(this.modalImport, "corsi", []);
            formData.append("file", file);
            try {
                const csrfMeta = document.querySelector('meta[name="csrf-token"]');
                const response = await fetch(this.importapi, {
                    method: "POST",
                    headers: csrfMeta ? {"X-CSRF-TOKEN": csrfMeta.getAttribute("content")} : {},
                    body: formData,
                });
                if (!response.ok) throw new Error("Errore durante l'importazione");
                const data = await response.json();
                console.log("✅ Dati importati:", data);
                if (data.corsi) {
                    this.$set(this.modalImport, "corsi",data.corsi);
                    this.modalImport.success = data.success;
                }
            } catch (error) {
                console.error("❌ Errore importazione Excel:", error);
                alert("Errore nell'importazione del file.");
                this.modalImport.success = false;
                this.$set("modalImport", "corsi", []);
            }
        },
        finishImport() {
            this.modalImport.corsi.forEach((c) => {
                this.finalData.corsi.push(_.cloneDeep(c))
            });
            this.$set(this.modalImport, "corsi", []);
            this.modalImport.show = false;
        }
    },
    mounted() {
        this.$set(this.finalData, 'corsi', []);
        if (this.source) {
            if (this.source.corsi) {
                if (Array.isArray(this.source.corsi))
                    this.finalData.corsi = this.source.corsi;
                this.finalData.corsi.forEach((item) => {
                    if (typeof item.gruppi === 'undefined') {
                        item.gruppi = [];
                    }
                    if (typeof item.moduli === 'undefined') {
                        item.moduli = [];
                    }
                });

            }
        }
        this.ready = true;
    }
}

</script>
